
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emprestimo-pessoal",
      function () {
        return require("private-next-pages/emprestimo-pessoal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emprestimo-pessoal"])
      });
    }
  